import { render } from "./TrainerList.vue?vue&type=template&id=3e7fe8d1&scoped=true&ts=true"
import script from "./TrainerList.vue?vue&type=script&lang=ts"
export * from "./TrainerList.vue?vue&type=script&lang=ts"

import "./TrainerList.vue?vue&type=style&index=0&id=3e7fe8d1&lang=scss&scoped=true"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7fe8d1"]])

export default __exports__